import styled from "styled-components";

export const DivContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
